<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        v-if="!loading"
        outlined >
        
        <v-img
          class="image-banner"
          v-if="auditorium.banner"
          fixed
          :src="url_banner"
          height="120px"
        ></v-img>
        
        <v-row class="ma-0">
          <v-col cols="12" md="8" sm="12" class="contenedor-imagen">
            <v-img
              fixed
              class="image-miniature"
              :aspect-ratio="16/9"
              :src="url_miniature"
            >
            </v-img>
          </v-col>

          <v-col cols="12" md="4" sm="12">

            <h3 class="text-center section-chat">CHAT</h3>
            
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-8 d-sm-flex">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'auditoriumsEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-spacer />
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'showAuditoriumEdition',

    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      activeChat: true,
      auditorium:[],
      name:null,

      entrepreneurship:[],

      banner:null,
      url_banner:null,

      miniature:null,
      url_miniature:null,
    }),

    methods:{
      async getAuditorium(){
        await axios.get('admin/editions/'+this.edition_id+'/auditoriums/'+this.auditorium_id ).then(response =>{
          this.data = response.data.data
          this.auditorium = response.data.data.auditorium

          if(this.auditorium.banner){
            this.url_banner = APP_URL + this.auditorium.banner
          }

          if(this.auditorium.miniature){
            this.url_miniature = APP_URL + this.auditorium.miniature
          }

          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },
    },

    created(){
       this.edition_id = this.$route.params.edition_id;
       this.auditorium_id = this.$route.params.auditorium_id;
       this.getAuditorium()
    },
  }
</script>
<style>
.images {
  position: fixed;
}
</style>
<style scoped>
.image-banner{
	position: relative;
	width: 100%;
  border-bottom: 5px solid #00a1b8;
}

.contenedor-imagen {
  position: relative;
  display: inline-block; /* O cualquier otro valor que se ajuste a tu diseño */
}


.image-miniature{
	position: relative;
	width: 100%;
  border-radius: 4px;
  border: 2px solid #00a1b8;
  display: block;
}

.section-chat{
  padding-top: 4px;
  position: relative;
	width: 100%;
  min-height:100%;
  border-radius: 4px;
  border: 1px solid #00a1b8;
}
</style>